module.exports = __webpack_public_path__ + "static/media/rosa-win.afcae17e.png";